import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-tarjeta-resumen-datos',
  templateUrl: './tarjeta-resumen-datos.component.html',
  styleUrl: './tarjeta-resumen-datos.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TarjetaResumenDatosComponent {
  @Input() titulo!: string;
  @Input() subtitulo!: string;
  @Input() icono!: string;
  @Input() color!: string;
  @Input() cargando!: boolean;
}
